<div class="row">
    <div class="white">
        <div class="col-xs-12 col-sm-8 col-md-8 text-left">
            <p class="small">
                Copyright © {{ year }} Vistek Ltd. All Rights Reserved. Prices, specifications, and images are subject to change without notice. <br />
                Manufacturer rebates, terms, conditions, and expiration dates are subject to manufacturers printed forms. <br />
                Prices are in Canadian Dollars. <br />
                Version: {{ version }}
            </p>
        </div>
    </div>
    <div class="col-xs-12 col-sm-4 col-md-4 text-right">
        <a href="#" class="btn btn-primary up" aria-label="To Top"
            ><span class="glyphicon glyphicon-arrow-up"></span
        ></a>
    </div>
</div>
